var _style, _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActivities(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "activities_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 148 148",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".activities_svg__st0{fill:none;stroke:var(--color-text);stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "activities_svg__st0",
    cx: 91.5,
    cy: 27.1,
    r: 14
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91.5 35c4.4 0 8-3.6 8-8s-3.6-8-8-8-8 3.6-8 8c.1 4.5 3.6 8 8 8z",
    fill: "var(--color-icon-secondary)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "activities_svg__st0",
    d: "M95.1 46.5l9.9 13.6 10.6-7.5c2.3-1.6 5.4-1.1 7.1 1.1l.2.3c1.7 2.3 1.2 5.4-1 7.1l-15.6 12c-2.2 1.7-5.3 1.2-6.9-1l-9.9-13.9M89.4 58.1L76.7 83.7 95.2 93c3.4 1.7 4.9 5.8 3.5 9.3L86.8 131c-1.4 3.3-5.3 4.9-8.6 3.3-3.1-1.4-4.5-5-3.2-8.1l8.6-21.8c.4-1.1 0-2.3-1.1-2.9l-15.6-7.7c-2-1-4.3 0-5 2.1l-6.8 20c-.4 1.3-1.2 2.4-2.3 3.2l-19.6 14.5c-2.6 1.9-6.3 1.3-8.1-1.4-1.5-2.3-1.2-5.4.9-7.3l16-14.6c.9-.8 1.5-1.8 1.9-3l5.3-17.6c1.8-6 4.1-11.8 6.9-17.4L68.2 48l-18.4-1.3-2 10.5c-.6 3-3.6 4.9-6.5 4-2.6-.8-4.1-3.5-3.5-6.2l3.1-15.2c.5-2.3 2.5-4 4.9-3.9l28.2.6"
  })));
}
export default SvgActivities;